enum QueryTypes {
  simplePath = 'SIMPLE_PATH', // [{type: sometype}] currently descends
  directedPath = 'DIRECTED_PATH', // [{type: sometype, direction: [PARENT/CHILD]]}
  filteredGet = 'FILTERED_GET',
  searchByType = 'SEARCH_BY_TYPE',
  LIST_LIMITED_ALL_TYPES = 'LIST_LIMITED_ALL_TYPES',
}
enum PathDirection {
  parent = 'PARENT',
  child = 'CHILD',
}
enum FilterTypes {
  simpleAnd = 'SIMPLE_AND',
}
enum ConditionTypes {
  between = 'BETWEEN',
  beginsWIth = 'BEGINS_WITH',
  contains = 'CONTAINS',
  equals = '=',
  notEquals = '<>',
  and = 'and',
}

export { QueryTypes, PathDirection, FilterTypes, ConditionTypes }
